var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "refund-detail-tab" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "basic-info",
          attrs: { shadow: "hover" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("退货单/订单号:"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.refundData.returnId) +
                        " / " +
                        _vm._s(_vm.refundData.orderId || "")
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("下单时间:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.refundData.addTime))),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("买家信息:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm.refundData.userId
                      ? _c("div", [
                          _vm._v("用户ID: " + _vm._s(_vm.refundData.userId)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.refundData.mobile
                      ? _c("div", [
                          _vm._v("手机: " + _vm._s(_vm.refundData.mobile)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("退款原因:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.refundData.reason || "")),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("门店:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.refundData.storeName || "")),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("支付方式:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.getPayTypeText(_vm.refundData.paymentMethod))
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("退单商品:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.formatGoodsList(_vm.refundData.goodsList))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("订单金额:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          _vm.refundData.orderAmount
                            ? parseFloat(_vm.refundData.orderAmount).toFixed(2)
                            : "0.00"
                        )
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("退款金额 (用户申请):"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          _vm.refundData.returnMoney
                            ? parseFloat(_vm.refundData.returnMoney).toFixed(2)
                            : "0.00"
                        )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("退款状态:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getReturnStatusText(_vm.refundData.returnStatus)
                      )
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("退款类型:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.getReturnTypeText(_vm.refundData.returnType))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "label" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.refundData.remark
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("备注:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.refundData.remark)),
                      ]),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.refundData.auditTime ||
      _vm.refundData.auditBy ||
      _vm.refundData.reasonRefusal
        ? _c(
            "el-card",
            { staticClass: "approval-section", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("业务核实审批")])]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("审批时间:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(_vm.refundData.auditTime))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("审批人:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.refundData.auditBy || "")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.refundData.reasonRefusal
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("审核备注:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.refundData.reasonRefusal)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.refundData.financeRemark ||
      _vm.refundData.financeTime ||
      _vm.refundData.financeBy
        ? _c(
            "el-card",
            { staticClass: "finance-section", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("财务退款处理")])]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("审批时间:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(_vm.refundData.financeTime))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("审批人:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.refundData.financeBy || "")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.refundData.financeRemark
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("财务备注:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.refundData.financeRemark)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canOperate
        ? _c(
            "el-card",
            { staticClass: "action-section", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("审核操作")])]
              ),
              _vm._v(" "),
              _vm.refundData.returnStatus === 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.auditForm,
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款金额" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  max: _vm.refundData.orderAmount || 0,
                                  precision: 2,
                                  step: 0.01,
                                },
                                model: {
                                  value: _vm.auditForm.returnMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.auditForm, "returnMoney", $$v)
                                  },
                                  expression: "auditForm.returnMoney",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    color: "#909399",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            订单金额: ¥" +
                                      _vm._s(
                                        _vm.refundData.orderAmount
                                          ? parseFloat(
                                              _vm.refundData.orderAmount
                                            ).toFixed(2)
                                          : "0.00"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "操作" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.auditForm.action,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.auditForm, "action", $$v)
                                    },
                                    expression: "auditForm.action",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "approve" } },
                                    [_vm._v("同意退款")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "reject" } },
                                    [_vm._v("拒绝退款")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "审核备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder:
                                    _vm.auditForm.action === "reject"
                                      ? "请输入拒绝原因"
                                      : "请输入审核备注",
                                },
                                model: {
                                  value: _vm.auditForm.reasonRefusal,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.auditForm,
                                      "reasonRefusal",
                                      $$v
                                    )
                                  },
                                  expression: "auditForm.reasonRefusal",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    loading: _vm.auditing,
                                  },
                                  on: { click: _vm.handleAudit },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.auditForm.action === "reject"
                                          ? "确认拒绝"
                                          : "确认通过"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { on: { click: _vm.resetAuditForm } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.refundData.returnStatus === 4
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.financeForm,
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入退款备注",
                                },
                                model: {
                                  value: _vm.financeForm.returnNote,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.financeForm, "returnNote", $$v)
                                  },
                                  expression: "financeForm.returnNote",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.confirming,
                                  },
                                  on: { click: _vm.handleConfirmRefund },
                                },
                                [_vm._v("\n            确认退款\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { loading: _vm.backingOff },
                                  on: { click: _vm.handleBackOff },
                                },
                                [_vm._v("回退状态")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-alert",
                        {
                          staticStyle: { "margin-top": "20px" },
                          attrs: {
                            title: "提示",
                            type: "warning",
                            closable: false,
                          },
                        },
                        [
                          _c("template", { slot: "default" }, [
                            _c("div", [
                              _vm._v(
                                "确认退款后将调用天财POS和CRM接口执行实际退款操作"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "退款金额: ¥" +
                                  _vm._s(
                                    _vm.refundData.returnMoney
                                      ? parseFloat(
                                          _vm.refundData.returnMoney
                                        ).toFixed(2)
                                      : "0.00"
                                  )
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm.refundData.returnStatus === 5 ||
                  _vm.refundData.returnStatus === 6 ||
                  _vm.refundData.returnStatus === 9
                ? _c(
                    "div",
                    [
                      _c("el-alert", {
                        attrs: {
                          title: _vm.getRefundFinalMessage(),
                          type:
                            _vm.refundData.returnStatus === 5
                              ? "error"
                              : "success",
                          closable: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("h2", [_vm._v("退款单详情")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }